// extracted by mini-css-extract-plugin
export default {"checkout_summary":"fz","checkout_summary_wrapper":"gz","summary_items":"hz","line_items_wrapper":"iz","separator":"jz","order_summary":"kz","line_item":"lz","order__summary_item_title":"mz","recurringdis":"nz","note":"oz","carbon_emission":"pz","unlock_savings":"qz","member_perk":"rz","info":"sz","no_items":"tz","promo":"uz","order_summary_mobile":"vz","open_summary_mobile":"wz","fixed_bottom_info":"xz","open_info":"yz","text":"zz","open_summary":"Az"};
    if(module.hot) {
      // 1711394578358
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  